import Messages from '../services/message.service';

const MessageMixin = {
  async mounted() {
    this.messageListener = {message: this.onMessage};
    await Messages.addListener(this.messageListener);
  },
  async beforeDestroy() {
    await Messages.unsubscribe(this.addedMessageChannels, this.messageListener, this.messageKey);
  },
  methods: {
    async unsubscribeIfNeeded() {
      if (this.addedMessageChannels && this.addedMessageChannels.length && this.messageListener) {
        await Messages.unsubscribe(this.addedMessageChannels, this.messageListener, this.messageKey);
      }
    },
    async addChannel(channel) {
      this.addedMessageChannels.push(channel);
      return Messages.addChannel(channel);
    },
    async removeChannel(channel) {
      return Messages.removeChannel(channel);
    },
    async resetMessages() {
      return Messages.teardown();
    }
  },
  data() {
    return {
      addedMessageChannels: [],
      messageListener: null
    };
  }
};
export default MessageMixin;
